import Lista from './Lista';

export const IndisponibilidadeLista = Lista;
